import React from "react";
import { Outlet } from "react-router-dom";

const VendorProjects = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default VendorProjects;
